export const STATUS_REQUEST = {
  PENDING: 'pending',
  SUCCESS: 'success',
  ERROR: 'error',
};
